/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { LandingFAQ } from './model/landingFAQ';

/**
 * Returns fact interpolated FAQs for a given SEO location.
 */
export const apiSeoLocationCityFaqsList = (
  countryUrlPrefix: string,
  language: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<LandingFAQ[]>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${language}/${city}--${regionSlug}--${seoSlug}/faqs/`,
    method: 'GET',
    signal,
  });
};

export const getApiSeoLocationCityFaqsListQueryKey = (
  countryUrlPrefix?: string,
  language?: string,
  city?: string,
  regionSlug?: string,
  seoSlug?: string
) => {
  return [
    `/api/v7/seo-location/${countryUrlPrefix}/${language}/${city}--${regionSlug}--${seoSlug}/faqs/`,
  ] as const;
};

export const getApiSeoLocationCityFaqsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSeoLocationCityFaqsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSeoLocationCityFaqsList>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSeoLocationCityFaqsListQueryKey(countryUrlPrefix, language, city, regionSlug, seoSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSeoLocationCityFaqsList>>> = ({
    signal,
  }) => apiSeoLocationCityFaqsList(countryUrlPrefix, language, city, regionSlug, seoSlug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && language && city && regionSlug && seoSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiSeoLocationCityFaqsList>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiSeoLocationCityFaqsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSeoLocationCityFaqsList>>
>;
export type ApiSeoLocationCityFaqsListQueryError = ErrorType<unknown>;

export function useApiSeoLocationCityFaqsList<
  TData = Awaited<ReturnType<typeof apiSeoLocationCityFaqsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSeoLocationCityFaqsList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSeoLocationCityFaqsListQueryOptions(
    countryUrlPrefix,
    language,
    city,
    regionSlug,
    seoSlug,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
